import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";

export const CarCard = ({ car, index = 0 }) => {
  const price =
    car.listing_type === "rent"
      ? `${car.price.toLocaleString()} €/ημέρα`
      : `${car.price.toLocaleString()} €`;

  return (
    <Link
      to={`/cars/${car.id}`}
      data-testid={`car-card-${car.id}`}
      className="card-listing group block fade-in"
      style={{ animationDelay: `${index * 70}ms` }}
    >
      <div className="aspect-[4/3] overflow-hidden bg-[#0A0A0A] relative">
        <img
          src={car.images?.[0] || "https://images.unsplash.com/photo-1567808291548-fc3ee04dbcf0?w=1200"}
          alt={car.title}
          className="w-full h-full object-cover"
        />
        <div className="absolute top-4 left-4">
          <span className="label-caps bg-black/60 backdrop-blur-md px-3 py-1.5 border border-[var(--gold)]/30">
            {car.listing_type === "rent" ? "Ενοικίαση" : "Πώληση"}
          </span>
        </div>
        <div className="absolute top-4 right-4 opacity-0 group-hover:opacity-100 transition-opacity">
          <div className="h-10 w-10 bg-[var(--gold)] flex items-center justify-center">
            <ArrowUpRight size={18} className="text-black" />
          </div>
        </div>
      </div>
      <div className="p-6">
        <div className="text-xs text-gray-500 tracking-[0.2em] uppercase mb-2 font-display">
          {car.year} · {car.body_type}
        </div>
        <h3 className="font-display text-xl font-bold tracking-tight text-white mb-3 group-hover:text-[var(--gold-bright)] transition-colors">
          {car.title}
        </h3>
        <div className="flex items-end justify-between pt-3 border-t border-white/5">
          <div>
            <div className="text-[0.65rem] text-gray-500 uppercase tracking-widest font-display">
              {car.listing_type === "rent" ? "Ανά Ημέρα" : "Τιμή"}
            </div>
            <div className="font-display text-2xl font-bold gold-gradient">{price}</div>
          </div>
          <div className="text-right">
            <div className="text-[0.65rem] text-gray-500 uppercase tracking-widest font-display">Ισχύς</div>
            <div className="text-sm text-gray-300">{car.horsepower} ίπποι</div>
          </div>
        </div>
      </div>
    </Link>
  );
};
